var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 14,
    fill: "#F2F2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15.2495H26.25L23.65 13.2995C22.68 12.5695 21.32 12.5695 20.35 13.2995L17.75 15.2495H15.5C14.26 15.2495 13.25 16.2595 13.25 17.4995C13.25 18.7395 14.26 19.7495 15.5 19.7495H28.5C29.74 19.7495 30.75 18.7395 30.75 17.4995C30.75 16.2595 29.74 15.2495 28.5 15.2495ZM21.25 14.4995C21.69 14.1695 22.31 14.1695 22.75 14.4995L23.75 15.2495H20.25L21.25 14.4995ZM28.5 18.2495H15.5C15.09 18.2495 14.75 17.9095 14.75 17.4995C14.75 17.0895 15.09 16.7495 15.5 16.7495H28.5C28.91 16.7495 29.25 17.0895 29.25 17.4995C29.25 17.9095 28.91 18.2495 28.5 18.2495Z",
    fill: "#A3A1AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6198 21.2588C28.2098 21.1888 27.8298 21.4688 27.7598 21.8788L26.6798 28.3688C26.4998 29.4588 25.5698 30.2488 24.4598 30.2488H19.5398C18.4398 30.2488 17.4998 29.4588 17.3198 28.3688L16.2398 21.8788C16.1698 21.4688 15.7798 21.1988 15.3798 21.2588C14.9698 21.3288 14.6998 21.7188 14.7598 22.1188L15.8398 28.6088C16.1398 30.4288 17.6998 31.7388 19.5398 31.7388H24.4598C26.2998 31.7388 27.8598 30.4188 28.1598 28.6088L29.2398 22.1188C29.3098 21.7088 29.0298 21.3288 28.6198 21.2588Z",
    fill: "#A3A1AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8298 27.75C19.8298 27.75 19.9098 27.75 19.9498 27.75C20.3598 27.68 20.6298 27.29 20.5698 26.89L19.7398 21.89C19.6698 21.48 19.2898 21.21 18.8798 21.27C18.4698 21.34 18.1998 21.73 18.2598 22.13L19.0898 27.13C19.1498 27.5 19.4698 27.76 19.8298 27.76V27.75Z",
    fill: "#A3A1AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1702 27.7488C24.5302 27.7488 24.8502 27.4888 24.9102 27.1188L25.7402 22.1188C25.8102 21.7088 25.5302 21.3288 25.1202 21.2588C24.7102 21.1888 24.3302 21.4688 24.2602 21.8788L23.4302 26.8788C23.3602 27.2888 23.6402 27.6688 24.0502 27.7388C24.0902 27.7388 24.1302 27.7388 24.1702 27.7388V27.7488Z",
    fill: "#A3A1AA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trashBin.9fea32ee.svg";
export { ForwardRef as ReactComponent };